import { useEffect, useState, useCallback } from "react";
import { translationService } from "features/editor/services/translation";
import type { ITranslationLog } from "features/workspaces/types";

export const useFetchItemLogs = (id: number | undefined) => {
  const [logs, setLogs] = useState<ITranslationLog[]>([]);
  const [isFetching, setIsFetching] = useState<boolean>(typeof id === "undefined");
  const [refetchIndex, setRefetchIndex] = useState(0);

  const refetch = useCallback(() => {
    setRefetchIndex(prevRefetchIndex => prevRefetchIndex + 1);
  }, []);

  useEffect(() => {
    if (typeof id === "undefined") {
      setIsFetching(false);
      return;
    }

    const abortController = new AbortController();

    async function fetchData() {
      setIsFetching(true);

      try {
        const response: ITranslationLog[] = await translationService.getLogs(id!, abortController);

        if (response && Array.isArray(response)) {
          const sortedList = response
            .sort((a, b) => new Date(b.logDate).getTime() - new Date(a.logDate).getTime())
            .slice(0, 3);
          setLogs(sortedList);
        } else {
          setLogs([]);
        }
      } catch (error) {
        console.error(error);
      }

      setIsFetching(false);
    }

    fetchData();

    return () => {
      abortController.abort();
    };
  }, [id, refetchIndex]);

  return { logs, isFetching, refetch };
};
